import { z } from 'zod';
import { extendedSocialUserInfoGuard } from '../sso-connector.js';
import { VerificationType } from './verification-type.js';
export const enterpriseSsoVerificationRecordDataGuard = z.object({
    id: z.string(),
    connectorId: z.string(),
    type: z.literal(VerificationType.EnterpriseSso),
    enterpriseSsoUserInfo: extendedSocialUserInfoGuard.optional(),
    issuer: z.string().optional(),
});
